// Copyright (c) 2016 Deere & Company

import TimestampUser from '@deere/cps-it.warranty-model-factory/lib/timestamp-user';
import actions from '../../actions-list';
import {createNewTransfer} from '../../shared/repositories';
import moment from 'moment';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';

export const createTransfer = () =>
    (dispatch, getState) => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        const createTransferData = {
            currentDealer: getState().createTransfer.product.dealer,
            id: '0',
            newDealer: getState().createTransfer.newTransfer.newDealer,
            product: getState().createTransfer.product,
            reasonForChange: getState().createTransfer.newTransfer.reasonForChange,
            requestDate: moment.utc().startOf('day').valueOf(),
            requestedBy: new TimestampUser({
                firstName: getState().user.details.firstName,
                id: getState().user.details.id,
                lastName: getState().user.details.lastName
            }),
            status: 'NEW'
        };

        return createNewTransfer(createTransferData)
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.CREATE_NEW_TRANSFER_SUCCESS
                });

                dispatch({
                    type: actions.RESET_NEW_TRANSFER
                });

                dispatch(routerActions.goBack());

                successAlertBar('TRANSFER_CREATED');

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/create-new-transfer.js